// Generated by purs version 0.13.0
"use strict";
var Chip_Model_Direction = require("../Chip.Model.Direction/index.js");
var Data_Eq = require("../Data.Eq/index.js");
var Data_Show = require("../Data.Show/index.js");
var Solid = (function () {
    function Solid() {

    };
    Solid.value = new Solid();
    return Solid;
})();
var Invisible = (function () {
    function Invisible() {

    };
    Invisible.value = new Invisible();
    return Invisible;
})();
var Hidden = (function () {
    function Hidden() {

    };
    Hidden.value = new Hidden();
    return Hidden;
})();
var Blue = (function () {
    function Blue() {

    };
    Blue.value = new Blue();
    return Blue;
})();
var Fake = (function () {
    function Fake() {

    };
    Fake.value = new Fake();
    return Fake;
})();
var Recessed = (function () {
    function Recessed() {

    };
    Recessed.value = new Recessed();
    return Recessed;
})();
var Flat = (function () {
    function Flat(value0) {
        this.value0 = value0;
    };
    Flat.create = function (value0) {
        return new Flat(value0);
    };
    return Flat;
})();
var showWallType = new Data_Show.Show(function (v) {
    if (v instanceof Solid) {
        return "#";
    };
    if (v instanceof Invisible) {
        return "X";
    };
    if (v instanceof Hidden) {
        return "H";
    };
    if (v instanceof Blue) {
        return "%";
    };
    if (v instanceof Fake) {
        return "'";
    };
    if (v instanceof Recessed) {
        return "O";
    };
    if (v instanceof Flat) {
        return "FLAT";
    };
    throw new Error("Failed pattern match at Chip.Model.WallType (line 21, column 10 - line 28, column 23): " + [ v.constructor.name ]);
});
var eqWallType = new Data_Eq.Eq(function (x) {
    return function (y) {
        if (x instanceof Solid && y instanceof Solid) {
            return true;
        };
        if (x instanceof Invisible && y instanceof Invisible) {
            return true;
        };
        if (x instanceof Hidden && y instanceof Hidden) {
            return true;
        };
        if (x instanceof Blue && y instanceof Blue) {
            return true;
        };
        if (x instanceof Fake && y instanceof Fake) {
            return true;
        };
        if (x instanceof Recessed && y instanceof Recessed) {
            return true;
        };
        if (x instanceof Flat && y instanceof Flat) {
            return Data_Eq.eq(Chip_Model_Direction.eqDirection)(x.value0)(y.value0);
        };
        return false;
    };
});
module.exports = {
    Solid: Solid,
    Invisible: Invisible,
    Hidden: Hidden,
    Blue: Blue,
    Fake: Fake,
    Recessed: Recessed,
    Flat: Flat,
    eqWallType: eqWallType,
    showWallType: showWallType
};
